module.exports = __webpack_public_path__ + "img/2025-06.490187db.jpg";